<template>
  <el-popover
    width="270"
    popper-class="staff-popover"
    trigger="hover"
    :placement="placement"
    :open-delay="500"
    :disabled="!staffId || staffId.length < 4"
    @show="getStaffInfo"
  >
    <staff :staffInfo="staffInfo"></staff>
    <template slot="reference">
      <slot name="reference"></slot>
    </template>
  </el-popover>
</template>
<script>
import Staff from "@/components/BaseComponents/Staff"
import { getSimpleUser } from "@/api/user"
import { getUser } from "@/utils/user"
export default {
  name: "staff-popover",
  props: {
    staffId: String,
    placement: {
      type: String,
      default: "bottom"
    }
  },
  components: {
    Staff
  },
  data() {
    return {
      staffInfo: {}
    }
  },
  methods: {
    async getStaffInfo() {
      if (!this.staffId) return
      let user = getUser(this.staffId)
      if (user) {
        Object.assign(user, {
          departmentNameStr: user.companyScope?.departmentNames,
          position: user.companyScope?.position,
          superior: user.companyScope?.superiorName
        })
      } else {
        user = await getSimpleUser({ userId: this.staffId })
        user.departmentNameStr = user.departmentNames?.join(",")
      }
      this.staffInfo = user
    }
  }
}
</script>

<style lang="scss">
.staff-popover.el-popover {
  padding: 0;
}
</style>
